export const scrollToCenter = () => {
  if (!document) {
    return;
  }

  // Find all hotspot grid items
  const allItems = document.querySelectorAll(".hotspot-grid-item");

  if (allItems && allItems.length > 0) {
    // Calculate grid dimensions (assuming square grid like 6x6)
    const gridSize = Math.sqrt(allItems.length);

    // Calculate the center row and column
    const centerRow = Math.floor(gridSize / 2);
    const centerCol = Math.floor(gridSize / 2);

    // Convert 2D position to linear index
    const centerIndex = centerRow * gridSize + centerCol;
    const centerElement = allItems[centerIndex];

    if (centerElement) {
      centerElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      return;
    }
  }
};

export const scrollToRandom = () => {
  if (!document) {
    return;
  }
  const allItems = document.querySelectorAll(".hotspot-grid-item");
  if (!allItems) {
    return;
  }
  const randomIndex = Math.floor(Math.random() * allItems.length);
  const randomElement = allItems[randomIndex];
  randomElement.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "center",
  });
};
